const { __ } = window.wp.i18n;
const { allSettings, defaultFields } = window.wc.wcSettings;

/**
 * Modifies the address fields in the WooCommerce settings.
 *
 * This function performs the following modifications:
 * - Removes specific address fields from the settings.
 * - Moves the "address_2" field to a new index.
 *
 * @function SpfAddressFieldModifications
 * @global
 */
export function SpfAddressFieldModifications() {
  if (!window.wc) return;
  const { allSettings, defaultFields } = window.wc.wcSettings;
  // Remove selected address fields
  delete allSettings.addressFieldsLocations.address[0]; // country
  delete allSettings.addressFieldsLocations.address[1]; // first_name
  delete allSettings.addressFieldsLocations.address[2]; // last_name
  delete allSettings.addressFieldsLocations.address[3]; // company
  delete allSettings.addressFieldsLocations.address[9]; // phone

  // Move selected address fields
  defaultFields["spf/address_2"].index = 45;

  const isEditor = wp.data.select("core/editor");

  if (isEditor) {
    window.wc.wcSettings.forcedBillingAddress = true;
  }
}

function addCustomValidation(fieldSelector, validationMessage, validationFunction) {
  const field = jQuery(fieldSelector);

  field.on("invalid", function (event) {
    event.target.setCustomValidity(validationMessage);
  });

  field.on("input", function (event) {
    if (validationFunction && !validationFunction(event.target.value)) {
      event.target.setCustomValidity(validationMessage);
    } else {
      event.target.setCustomValidity("");
    }
  });
}

function validateRequired(value) {
  return value.trim() !== "";
}

function validateEmail(value) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(value);
}

export function customValidate() {
  jQuery(document).ready(function ($) {
    addCustomValidation(
      "#contact-spf-checkout-repeat-email",
      __("Please enter a valid email address", "woocommerce"),
      validateEmail,
    );
    addCustomValidation("#billing-city", __("Niepoprawna miejscowość", "spf"), validateRequired);
  });
}
